import React from "react";
import "./Description.css";
import {useLanguage} from "../context/LanguageContext";
const Description = () => {
    const { language, setLanguage } = useLanguage();

    return (
    <div className="description">
        {language === 'en' ? (<h4 className="head">About</h4>): (<h4 className="head_ar">نبذة عامة</h4>)}

        {language === 'en' ? (<p>Discover eBooks on business to baking, plus live scores and news—all in one!
            </p>):
            (<p className="p_ar">اكتشف كتباً عن الأعمال للطبخ، ونتائج مباشرة وأخبار - كل هذا في مكان واحد!
            </p>)}
    </div>
  );
};

export default Description;
